module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "grid-menu"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('a', {
      class: {
        external: item.isExternal,
        'close-panel': !item.children,
      },
      attrs: {
        "target": item.isExternal ? '_blank' : null
      },
      on: {
        "click": function($event) {
          return _vm.onClick($event, item)
        }
      }
    }, [_c('div', [_c('span', {
      staticClass: "icon",
      class: _vm.getIconClass(item.iconId),
      style: ({
        color: _vm.iconColor
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "text",
      style: ({
        color: _vm.fontColor
      })
    }, [_vm._v(_vm._s(item.text))])])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14808e64", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14808e64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/grid-menu-items.component.vue
// module id = 738
// module chunks = 0